export default "__VITE_ASSET__DTODPI2p__"